import React, { useState } from "react";
import "./Products.css";
import {
  Globe,
  Globe2,
  CirclePower,
  EarthLock,
  Coins,
  CircleGauge,
  Compass,
Loader,
Disc,
Infinity,
MessageCircleX,


} from "lucide-react";

const products = [

    {
    Icon: Globe,
    title: "Data Labeling for AI",
    tagline: "Human-quality labels at machine speed",
    points: [
      "Expert-led annotation workflows",
  
      "Pay-as-you-go or managed service",
       "Image, text, audio, synthetic data, 3D formats and more",
    ],
    color: "#010101",
  },
   {
    Icon: Globe2,
    title: "Lex 3D World",
    tagline: "Build immersive digital spaces at scale",
    points: [
      "Host apps, offices, shops & more",
      "Rent, sell or monetize digital real estate",
      "Perfect for branding, events & gamification",
    ],
    color: "#010101",
  },
  {
    Icon:  Compass, 
    title: "AI App Builder",
    tagline: "Build AI apps in minutes, no-code",
    points: [
      "Turn your ideas into AI apps",
      "Share and monetize your apps",
      "Turn your apps into recurring revenue",
      "Ready to make your first million dollars?",
    ],
    color: "#010101",
  },

  {
    Icon: Loader,
    title: "AI Game Builder",
    tagline: "Drag-and-drop worlds & NPC logic",
    points: [
      "No-code 3D level designer",
      "AI-generated characters & quests",
      "One-click deploy to Web, PC & Mobile",
      "Monetize via in-game marketplaces",
    ],
    color: "#010101",
  },


 
  {
    Icon: CirclePower,
    title: "Lex AI Employee",
    tagline: "Your 24/7 AI employee with trust",
    points: [
      "Custom-trained to your workflows",
      "Automates repetitive tasks & approvals",
      "Boosts your revenue, ROI & KPI tracking",
    ],
    color: "#010101",
  },
  {
    Icon: EarthLock,
    title: "Lex Private AI",
    tagline: "Enterprise-grade AI behind your firewall",
    points: [
      "Full data control on-premise or VPC",
      "Ideal for law firms, finance & government",
      "Zero exposure to public internet",
    ],
    color: "#010101",
  },
  {
    Icon: Coins,
    title: "Lex Affiliate Program",
    tagline: "Earn lifetime commissions on referrals",
    points: [
      "20% on every sale, forever",
      "No upfront costs or caps",
      "Perfect for creators & influencers",
    ],
    color: "#010101",
  },
  {
    Icon: CircleGauge,
    title: "Customized Solutions",
    tagline: "End-to-end help launching your venture.",
    points: [
      "Entity setup, legal & hiring support",
      "Marketing, sales & product development",
      "A turnkey path from idea to revenue",
    ],
    color: "#010101",
  },
  {
  Icon: Infinity,
  title: "Lex Social Media",
  tagline: "Your AI-powered 3D world for life, work, and play.",
  points: [
    "Design immersive 3D spaces for every part of your life — from gym to study",
    "Chat, co-work, or date with AI companions and real people",
    "Visit virtual clinics, legal hubs, or financial advisors — all in one place",
    "Shop smarter, relax in AI wellness zones, or host your next meetup",
    "All-in-one: socialize, explore, learn, and thrive — powered by Lex AI",
  ],
  color:"#010101",
}

];

export default function Products() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleActive = idx => {
    setActiveIndex(prev => (prev === idx ? null : idx));
  };

  return (
    <section className="products-panel">
      {products.map(({ Icon, title, tagline, points, color }, idx) => (
        <article
          key={title}
          className={`product-item ${activeIndex === idx ? "is-active" : ""}`}
          onClick={() => toggleActive(idx)}
          onTouchEnd={e => {
            e.preventDefault();
            toggleActive(idx);
          }}
        >
          <div className="icon-title" style={{ color }}>
            <Icon size={60} />
            <h3>{title}</h3>
          </div>
          <p className="tagline">{tagline}</p>
          <ul>
            {points.map(p => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </article>
      ))}
    </section>
  );
}
